import { createElement } from 'react';
import { oneOf, node, string, bool } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'classnames';
import _Tabs from 'reakit/Tabs';
import _Tabs$1 from './styled.js';
import Tab from './Tab.js';
export { default as Tab, tabDefaultProps, tabPropTypes } from './Tab.js';
import TabPanel from './TabPanel.js';
export { default as TabPanel, tabPanelDefaultProps, tabPanelPropTypes } from './TabPanel.js';

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return createElement(_Tabs$1, _extends({
    use: _Tabs
  }, props), children);
};
Tabs.Tab = Tab;
Tabs.Panel = TabPanel;
Tabs.Container = _Tabs.Container;
var tabsPropTypes = {
  align: oneOf(['left', 'center', 'right']),
  children: node.isRequired,
  className: string,
  isFitted: bool,
  type: oneOf(['default', 'boxed'])
};
Tabs.propTypes = tabsPropTypes;
var tabsDefaultProps = {
  align: undefined,
  className: undefined,
  isFitted: false,
  type: 'default'
};
Tabs.defaultProps = tabsDefaultProps;
var C = Tabs;

export default C;
export { C as Tabs, tabsDefaultProps, tabsPropTypes };
